<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
    style="margin-top: 20px">

    <ng-container matColumnDef="nomeResponsavel">
        <th mat-header-cell *matHeaderCellDef> Responsável </th>
        <td mat-cell *matCellDef="let element"> {{element.nomeResponsavel}} </td>
    </ng-container>

    <ng-container matColumnDef="situacaoTipoAcao">
        <th mat-header-cell *matHeaderCellDef> Tipo de ação </th>
        <td mat-cell *matCellDef="let element"> {{element.situacaoTipoAcao}} </td>
    </ng-container>

    <ng-container matColumnDef="descricaoAcao">
        <th mat-header-cell *matHeaderCellDef> Descrição </th>
        <td mat-cell *matCellDef="let element"> {{element.descricaoAcao}} </td>
    </ng-container>

    <ng-container matColumnDef="dataPrazo">
        <th mat-header-cell *matHeaderCellDef> Data Prazo: </th>
        <td mat-cell *matCellDef="let element"> {{element.dataPrazo | dataSimples}} </td>
    </ng-container> 

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef > Ações </th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                <mat-icon>delete</mat-icon>
            </button>
            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                <mat-icon>create</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
    style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar nova ação" mat-fab color="primary" (click)="abrirFormAdicaoAcaoReuniao()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>